import React from "react";
import SocialMediaShare from "../../molecules/social-media-share";
import Share from "../other-icons/Share";
import "./horoscope-mobile-card.m.css";

const HoroscopeMobileCard = ({ index, item, text, shareClickHandler, updateStory, toggleSharing }) => {
  const { icon, name, key, dateRange } = item;
  return (
    <div styleName="wrapper" key={key} id={index + 1}>
      <div styleName="title-wrapper">
        <div styleName="title-left">
          <div styleName="title">{name}</div>
          <div styleName="date-range">{dateRange}</div>
        </div>
        <div styleName="title-right">
          <div onClick={shareClickHandler}>
            <Share color="black" height="18px" width="18px" />
          </div>
          <div styleName="social-share-wrapper">
            {toggleSharing === index && <SocialMediaShare story={updateStory} />}
          </div>
        </div>
      </div>
      <div styleName="description-wrapper">
        <div styleName="zodiac-sign">{icon}</div>
        <div styleName="description">{text}</div>
      </div>
    </div>
  );
};

export default HoroscopeMobileCard;
